var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H53C58.5228 0 63 4.47715 63 10V53C63 58.5228 58.5228 63 53 63H10C4.47715 63 0 58.5228 0 53V10Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5C21 11.701 25.701 7 31.5 7C37.299 7 42 11.701 42 17.5V25.5C42 31.299 37.299 36 31.5 36C25.701 36 21 31.299 21 25.5V17.5Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 42C13.7157 42 7 48.7157 7 57V63.0328C7.33052 63.0111 7.66397 63 8 63H55C55.336 63 55.6695 63.0111 56 63.0328V57C56 48.7157 49.2843 42 41 42H22Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal_icon.9d0def9e221424e4ae20a4e02ed21f12.svg";
export { ForwardRef as ReactComponent };